// Profile calls (Android ChangePasswordFragment). Never throws.
import { apiCall } from "./apiCall";

export const profileApi = {
  // Laravel PasswordUpdateRequest: password required|min:8|case_diff|numbers|letters|symbols; old_pwd = current password
  updatePassword: (password, oldPassword) => apiCall("post", "profile/password/update", { password, old_pwd: oldPassword }),
  // Edit Profile trash icon: clears profile_picture (Profile\CheckImageController@destroy) → ProResource
  removeImage: () => apiCall("delete", "profile/image/remove"),
};
